export default "__VITE_ASSET__09a2297a__"